/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_TitleInputs */

const en_admin_settings_title = /** @type {(inputs: Admin_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Settings`)
};

/**
* | output |
* | --- |
* | "System Settings" |
*
* @param {Admin_Settings_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_title = /** @type {((inputs?: Admin_Settings_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_title(inputs)
});
export { admin_settings_title as "admin.settings.title" }